import { Dialog as DialogPrimitive } from "radix-ui";

import { cn } from "../../lib/cn";

interface DialogDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

function DialogDescription({ children, className }: DialogDescriptionProps) {
  return (
    <DialogPrimitive.Description
      className={cn("text-sm font-medium leading-[1.2]", className)}
    >
      {children}
    </DialogPrimitive.Description>
  );
}

export { DialogDescription };
